import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("ofl_token", data.token);
    setUser(data);
    return data;
  };


  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // ignore — we still clear local state
    }
    localStorage.removeItem("ofl_token");
    setUser(false);
  };

  const updateUser = (patch) => {
    setUser((u) => ({ ...u, ...patch }));
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshUser: fetchMe, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function defaultLandingForRole(role) {
  if (role === "super_admin") return "/super-admin";
  if (role === "employee") return "/me";
  return "/";
}
